// extracted by mini-css-extract-plugin
export default {"storyListWrapper":"c-a_cC"};